module.exports = __webpack_public_path__ + "media/assets/icons/si-glyph_cocktail-3daeaf9f3b6727e08dbb95b3ae2be169.svg";